jQuery(function ($) {
    $(document).ready(function () {

        $('.flight__information-page .airline__block .mobile__airline-toggle').click(function () {
            $('.flight__information-page .airline__block .airline__grid').toggleClass('expanded_airline');
            $('.flight__information-page .airline__block .mobile__airline-toggle').toggleClass('rotate_chevron');

            if ($('.flight__information-page .airline__block .airline__grid').hasClass('expanded_airline')) {
                $('.flight__information-page .airline__block .airline__grid').slideDown();
            } else {
                $('.flight__information-page .airline__block .airline__grid').slideUp();
            }
        });

        $('.flight__information-page .gho__block .mobile__gho-toggle').click(function () {
            $('.flight__information-page .gho__block .gho__grid').toggleClass('expanded_airline');
            $('.flight__information-page .gho__block .mobile__gho-toggle').toggleClass('rotate_chevron');

            if ($('.flight__information-page .gho__block .gho__grid').hasClass('expanded_airline')) {
                $('.flight__information-page .gho__block .gho__grid').slideDown();
            } else {
                $('.flight__information-page .gho__block .gho__grid').slideUp();
            }
        });

        if ($('.homepage__flight-info').length > 0) {

            fetch_flights_data();

            /**
             * Running function every 2 minutes to update the flights
             */
            setInterval(function () {
                fetch_flights_data();
            }, 2 * 60 * 1000);

            $('.homepage__flight-info .flight__tabs .tab__title').click(function () {
                $('.homepage__flight-info .flight__tabs .tab__title').removeClass('active');

                let $this = $(this);
                $this.addClass('active');

                $('.homepage__flight-info .flight__tabs .tab__info.active').removeClass('active').fadeOut();

                let tab = $this.attr('data-control');
                $('.homepage__flight-info .flight__tabs .tab__info[data-tab=' + tab + ']').addClass('active').fadeIn();
            });

        }
    });

    function fetch_flights_data() {
        $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            dataType: "JSON",
            data: {
                action: "fetch_flight_information",
            },
            success: function (resp) {
                $('.flight__tabs-wrapper .spinner').fadeOut();

                if (resp.data.arrivals.table) {
                    $('.flight__tabs-wrapper #arrivals__tab table tbody').html(resp.data.arrivals.table);

                    $('.flight__tabs-wrapper #last__updated span').html(formatDateLocalized(resp.data.arrivals.updated_at));

                    function formatDateLocalized(dateString) {
                        // Parse the date string into a Date object
                        let date = new Date(dateString);

                        // Get the site locale (modify this if you retrieve it differently)
                        let locale = document.documentElement.lang || navigator.language || 'en';

                        if (locale.startsWith('bg')) {
                            // Bulgarian month abbreviations
                            const monthsBG = [
                                "яну", "фев", "мар", "апр", "май", "юни",
                                "юли", "авг", "сеп", "окт", "ное", "дек"
                            ];

                            // Extract day, month, year, hour, and minute
                            let day = date.getDate();
                            let month = monthsBG[date.getMonth()];
                            let year = date.getFullYear();
                            let hours = date.getHours().toString().padStart(2, '0');
                            let minutes = date.getMinutes().toString().padStart(2, '0');

                            // Return formatted date in Bulgarian
                            return `${day} ${month} ${year} г., ${hours}:${minutes}`;
                        } else {
                            // Default formatting for other locales (e.g., English)
                            return new Intl.DateTimeFormat(locale, {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            }).format(date);
                        }
                    }
                }

                if (resp.data.departures.table) {
                    $('.flight__tabs-wrapper #departures__tab table tbody').html(resp.data.departures.table);
                }
                $('.homepage__flight-info .flight__tabs .table__wrapper tbody tr').click(function () {
                    let datalink = $(this).attr('data-link');
                    if (datalink) {
                        window.location.href = datalink;
                    }
                });
            },
            error: function (errorThrown) {
                //Returns the thrown error
            }
        });
    }
});

